import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Container = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.space['2xl']} ${theme.space.md}`};
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin: 0 0 ${({ theme }) => theme.space.lg} 0;
`;

export const Title = styled.h2`
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const SeeAllLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: underline;
  }
`;

export const TrackWrapper = styled.div`
  position: relative;
`;

export const Track = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space.md};
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  outline: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Slide = styled.div`
  flex: 0 0 calc((100% - 3 * 16px) / 4);
  scroll-snap-align: start;

  @media (max-width: 1024px) {
    flex: 0 0 calc((100% - 2 * 16px) / 3);
  }

  @media (max-width: 640px) {
    flex: 0 0 calc((100% - 16px) / 2.25);
  }
`;

interface ArrowProps {
  $side: 'left' | 'right';
}

export const Arrow = styled.button<ArrowProps>`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'left' ? 'left: -16px;' : 'right: -16px;')}
  transform: translateY(-50%);
  z-index: 2;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.radius.full};
  border: 1px solid ${({ theme }) => theme.colors.border.color};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: opacity 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

export const SkeletonSlide = styled(Slide)`
  border-radius: ${({ theme }) => theme.radius.regular};
  overflow: hidden;
`;

export const SkeletonImage = styled.div`
  width: 100%;
  aspect-ratio: 3 / 4;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.background.secondary} 0%,
    ${({ theme }) => theme.colors.background.primary} 50%,
    ${({ theme }) => theme.colors.background.secondary} 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const SkeletonText = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: 14px;
  margin-top: ${({ theme }) => theme.space.sm};
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.background.secondary};
`;
